import { usePostAlterarEtapaSubetapa } from "services/api/Etapas_Subetapas/alterar-etapa-subetapa-post";
import { useGetEtapas } from "services/api/Etapas_Subetapas/etapas-get";
import { useGetSubetapas } from "services/api/Etapas_Subetapas/subetapas-get";
import { useEffect, useState } from "react";
import { useGetEtapasLead } from "services/api/Etapas_Subetapas/etapas-lead-get";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import MaterialUI from "../../../../material-UI";
import * as S from "./styles";

interface Props {
  onClose: Function;
  open: boolean;
  anchorLead?: any;
  anchorLeadCorretor?: any;
  anchorSubEtapa?: any;
  anchorEtapa?: any;
  refetch: any;
}

export function EtapasModalWarning(props: Props) {
  const { idRegionalSistemaOrigem } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [etapas, setEtapas] = useState<any>(
    props.anchorEtapa
      ? { label: props.anchorEtapa?.label, value: props.anchorEtapa?.value }
      : null
  );
  const [subEtapas, setSubEtapas] = useState<any>(
    props.anchorSubEtapa
      ? {
          label: props.anchorSubEtapa?.label,
          value: props.anchorSubEtapa?.value,
        }
      : null
  );

  const { data: dataEtapa } = useGetEtapasLead({
    idLead: props.anchorLeadCorretor,
  });

  const {
    data: dataSubEtapa,
    refetch: refetchSubEtapa,
    isFetching: isFetchingSubEtapa,
  } = useGetSubetapas({
    idsEtapas: [etapas?.value],
    idRegional: idRegionalSistemaOrigem,
  });

  const { mutate: mutateAlterar, isLoading: isLoadingAlterar } =
    usePostAlterarEtapaSubetapa();

  const handleSubmit = () => {
    if (etapas && subEtapas) {
      mutateAlterar(
        {
          idLeadCorretor: props.anchorLeadCorretor,
          idEtapaLead: etapas?.value,
          idSubEtapaLead: subEtapas?.value,
        },
        {
          onSuccess: () => {
            props.refetch();
            props.onClose();
          },
        }
      );
    }
  };

  useEffect(() => {
    if (etapas?.value) {
      refetchSubEtapa();
    }
  }, [etapas]);

  return (
    <S.Container>
      <S.SpaceY space={16} />
      <S.Autocomplete
        id="combo-box-demo"
        options={
          dataEtapa
            ? dataEtapa?.map((item: any) => {
                return { label: item?.nome, value: item?.id };
              })
            : []
        }
        value={etapas || null}
        renderInput={(params: any) => (
          <>
            <S.LabelText>Etapa</S.LabelText>
            <S.TextField
              placeholder="Selecione"
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              {...params}
            />
          </>
        )}
        getOptionLabel={(option: any) => option.label || ""}
        onChange={(event, newValue: any) => {
          setEtapas(newValue);
          setSubEtapas(null);
          // refetchSubEtapa();
        }}
      />
      <S.SpaceY space={8} />
      <S.Autocomplete
        id="combo-box-demo"
        options={
          dataSubEtapa
            ? dataSubEtapa?.subEtapas?.map((item: any) => {
                return { label: item?.nome, value: item?.id };
              })
            : []
        }
        disabled={isFetchingSubEtapa}
        value={subEtapas || null}
        renderInput={(params: any) => (
          <>
            <S.LabelText>Subetapa</S.LabelText>
            <S.TextField
              placeholder="Selecione"
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              {...params}
            />
          </>
        )}
        getOptionLabel={(option: any) => option.label || ""}
        onChange={(event, newValue: any) => {
          setSubEtapas(newValue);
        }}
      />
      <S.SpaceY space={32} />
      <S.Buttons>
        {/* <button
          className="secondary"
          type="button"
          onClick={() => {
            props.onClose();
          }}
        >
          Cancelar
        </button> */}
        <button
          className="primary"
          type="button"
          onClick={() => {
            handleSubmit();
          }}
        >
          {isLoadingAlterar ? (
            <MaterialUI.CircularProgress style={{ color: "#fff" }} size={22} />
          ) : (
            "Confirmar"
          )}
        </button>
      </S.Buttons>
    </S.Container>
  );
}
